/**
 * Facility / admin claims financial totals (V2 contract).
 *
 * Rollups (status, month, group, aggregates, totals):
 *   submitted_total | pa_approved_total | claims_approved_total
 *   total_cost === claims_approved_total (legacy)
 *
 * Per-claim cards:
 *   submitted_to_pa_total | pa_approved_total | claims_approved_total
 *   aliases: requested_total, filed_total, approved_total, display_cost, encounter_cost
 */

function toMoney(value) {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
}

/** Submitted to PA — prefer rollup key, then claim aliases. */
export function getSubmittedTotal(row) {
  return toMoney(
    row?.submitted_total ??
      row?.submitted_to_pa_total ??
      row?.requested_total ??
      0
  );
}

/** PA approved — prefer explicit, then filed_total alias. Do not use claims payable fields. */
export function getPaApprovedTotal(row) {
  return toMoney(row?.pa_approved_total ?? row?.filed_total ?? 0);
}

/**
 * Claims approved (payable). Prefer explicit payable fields; legacy total_cost
 * matches claims_approved_total on rollups. Avoid PA-only fields as final payable.
 */
export function getClaimsApprovedTotal(row) {
  return toMoney(
    row?.claims_approved_total ??
      row?.approved_total ??
      row?.display_cost ??
      row?.total_cost ??
      row?.encounter_cost ??
      0
  );
}

/** Primary amount shown on claim cards (amount due / approved for payment). */
export function getDisplayCost(row) {
  const canonical = Number(row?.display_cost);
  if (Number.isFinite(canonical)) return canonical;
  return getClaimsApprovedTotal(row);
}

/** All three amounts from a rollup or claim row. */
export function getFinancialTriple(row) {
  return {
    submitted: getSubmittedTotal(row),
    paApproved: getPaApprovedTotal(row),
    claimsApproved: getClaimsApprovedTotal(row),
  };
}
